import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _PropTypes from 'prop-types';
import * as React from 'react';
import styled from 'styled-components';
import { spacing2x, spacing4x } from '../../styles/spacing.js';
import { Alert, roleMap } from '../Alert/Alert.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["html", "message", "variant"];
var StyledAlert = styled(Alert).withConfig({
  displayName: "Banner__StyledAlert",
  componentId: "r2zzlc-0"
})(["&&{display:flex;align-items:center;padding:", ";min-height:38px;}"], spacing2x + " " + spacing4x);
var Banner = /*#__PURE__*/React.forwardRef(function Banner2(props, ref) {
  var html = props.html,
      message = props.message,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? "info" : _props$variant,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/jsx(StyledAlert, _objectSpread(_objectSpread({}, rest), {}, {
    type: "banner",
    variant: variant ? variant : "info",
    ref: ref,
    children: html ? /*#__PURE__*/jsx("span", {
      "aria-atomic": true,
      role: roleMap[variant],
      dangerouslySetInnerHTML: {
        __html: html
      }
    }) : /*#__PURE__*/jsx("span", {
      "aria-atomic": true,
      role: roleMap[variant],
      children: message
    })
  }));
});
Banner.propTypes = {
  "html": _PropTypes.string,
  "message": _PropTypes.node,
  "variant": _PropTypes.oneOf(["error", "info", "success", "warning"])
};
Banner.displayName = "Banner";

export { Banner };
